export default __webpack_public_path__ + "static/media/segre04.94922ed7.jpg";